import React, { useState } from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import ProductItem from "./components/ProductItem";
import { getRandomBio } from "./farmers";

const MeetTheFarmersTwo = () => {
  const [storedName] = useLocalStorage("name", null);
  const { farmersData, loading, errors } = useTraceabilityData();
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const farmers = farmersData?.mappedFarmers?.length
    ? farmersData.mappedFarmers
    : [];

  const goToNextSlide = () => {
    if (!farmers.length) return;
    setCurrentSlideIndex((prev) => (prev + 1) % farmers.length);
  };

  const goToPreviousSlide = () => {
    if (!farmers.length) return;
    setCurrentSlideIndex((prev) => (prev - 1 + farmers.length) % farmers.length);
  };

  const pageDescription =
    farmersData?.description ||
    "Our farmers are the backbone of everything we do, bringing generations of expertise and care to every step of the process. They work tirelessly to ensure that the highest standards are met, from nurturing their livestock to embracing sustainable farming methods.";

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Meet Our Farmers</h2>
      </div>

      {/* Intro */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {loading.farmers && "Loading farmers..."}
                {!loading.farmers && errors.farmers && "Error loading farmers data."}
                {!loading.farmers && !errors.farmers && pageDescription}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Farmer Profiles */}
      {/* Farmer Profiles */}
      {/* <div
        className="cw-slider-container"
        style={{ paddingTop: "29px", overflow: "hidden", position: "relative" }}
      >
        <div
          className="cw-slider"
          style={{
            display: "flex",
            transition: "transform 0.5s ease",
            transform: `translateX(-${currentSlideIndex * 100}%)`,
            width: "100%",
          }}
        >
          {farmers.map((farmer) => (
            <div
              key={farmer.id}
              className="cw-container"
              style={{
                flex: "0 0 100%",
                maxWidth: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "250px",
              }}
            >
              <div className="cw-content">
                <div className="cw-details">
                  <h2>{farmer.name}</h2>
                  <p>Registration No: {farmer.registrationNo}</p>
                  <p>DOB: {farmer.dob}</p>
                </div>
                <div className="cw-tab-content active">
                  <p className="max-w-56">{getRandomBio(farmer.name)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      
        <div className="cw-nav-buttons">
          <button className="cw-nav-btn" onClick={goToPreviousSlide}>
            &#9665;
          </button>
          <button className="cw-nav-btn" onClick={goToNextSlide}>
            &#9655;
          </button>
        </div>
      </div> */}


      <div
        className="cw-slider-container"
        style={{ paddingTop: "29px", position: "relative" }}
      >
        <div className="container">
          {farmers.map((farmer) => (
            <div
              key={farmer.id}
              className=" mb-3"

            >
              <div className="cw-content">
                <div className="cw-details">
                  <h2>{farmer.name}</h2>
                  <p>Registration No: {farmer.registrationNo}</p>
                  <p>DOB: {farmer.dob}</p>
                </div>
                <div className="cw-tab-content active">
                  <p className="">{getRandomBio(farmer.name)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>



      {/* Traceability Journey */}
      {/* <div className="wrapper2 mt-5">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div>
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />
            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />
            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />
            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />
            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />
            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName || "You"}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default MeetTheFarmersTwo;

